import React from 'react';
import { Stack, Text, Button } from '@moda/om';

import './ModaPrivateSuccessMessage.scss';

type Props = { onClose: () => void };

export const ModaPrivateSuccessMessage: React.FC<Props> = ({ onClose }) => {
  return (
    <Stack space={5}>
      <Stack space={4}>
        <Text className="ModaPrivateSuccessMessage__title" treatment="h3" family="serif">
          You are on the list.
        </Text>
        <Text className="ModaPrivateSuccessMessage__description">
          A personal stylist will review your information and get back to you shortly.
        </Text>
      </Stack>
      <Button className="ModaPrivateSuccessMessage__button" onClick={onClose}>
        Continue Shopping
      </Button>
    </Stack>
  );
};
